import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFolderType, updateFolderType, deleteFolderType } from '../../../../api/administration/edmsSettings/folderTypes';

export const useFolderTypeMutations = (queryKey = ['folderTypes']) => {
  const queryClient = useQueryClient();

  const invalidateFolderTypes = async () => {
    await queryClient.invalidateQueries({ queryKey, exact: false });
    await queryClient.invalidateQueries({ queryKey: ['folderTypes', 'active'], exact: false });
  };

  const createMutation = useMutation({
    mutationFn: createFolderType,
    onSuccess: () => invalidateFolderTypes(),
  });

  const updateMutation = useMutation({
    mutationFn: updateFolderType,
    onSuccess: () => invalidateFolderTypes(),
  });

  const deleteMutation = useMutation({
    mutationFn: deleteFolderType,
    onSuccess: () => invalidateFolderTypes(),
  });

  return {
    createMutation,
    updateMutation,
    deleteMutation,
  };
};

export default useFolderTypeMutations;
